(function () {

    'use strict';
    angular.module('app')
        .controller('newSocialWizardController',
            [
                '$location',
                '$routeParams',
                '$timeout',
                '$rootScope',
                '$sce',
                '$cookies',
                'companyService',
                'accountsService',
                newSocialWizardController 
            ]
        );

    function newSocialWizardController($location, $routeParams, $timeout, $rootScope, $sce, $cookies, companyService, accountsService) {
       
      
        var vm = this;
        vm.clientToken = $routeParams.ct;
        vm.waiting = true;
        vm.account = null;
        vm.companyAdmin = null;
        vm.users = [];
        vm.company = null;        
        vm.pager = null;
        vm.selectedUsers = [];

        function PagerButton(text, page, enabled, current) {
            this.text = $sce.trustAsHtml(text + '');
            this.page = page;
            this.enabled = enabled;
            this.current = current;
        }

        function Pager(response) {

            this.count = response.count;
            this.total = response.total;
            this.pageSize = response.count;

            this.totalPages = response.totalPages;
            this.currentPage = response.currentPage;
            this.canPrev = this.currentPage > 1;
            this.canNext = this.currentPage < this.totalPages;

            this.buttons = [];

            var totalButtons = 7; // ensure this is odd
            var pageSkip = 10;
            var startButton = 1;
            if (this
                .currentPage >
                Math.floor(totalButtons / 2)) startButton = this.currentPage - Math.floor(totalButtons / 2);

            var endButton = startButton + totalButtons - 1;
            if (endButton >= this.totalPages) endButton = this.totalPages;
            if (this.totalPages > totalButtons &&
                (endButton - startButton + 1) < totalButtons) {
                startButton = endButton - totalButtons + 1;
            }

            var prevPage = this.currentPage - pageSkip;
            if (prevPage < 1) prevPage = 1;

            var nextPage = this.currentPage + pageSkip;
            if (nextPage > this.totalPages) nextPage = this.totalPages;

            this.buttons.push(new PagerButton('<strong>&lt;&lt;</strong>', 1, this.currentPage != 1));
            this.buttons.push(new PagerButton('<strong>&lt;</strong>', prevPage, this.currentPage != 1));

            for (var i = startButton; i <= endButton; i++) {
                this.buttons.push(new PagerButton(i, i, true, i === this.currentPage));
            }

            this.buttons.push(new PagerButton('<strong>&gt;</strong>',
                nextPage,
                endButton <= this.totalPages && this.currentPage !== this.totalPages));
            this.buttons.push(new PagerButton('<strong>&gt;&gt;</strong>',
                this.totalPages,
                endButton <= this.totalPages && this.currentPage !== this.totalPages));
        }

        vm.getUsers = function (button) {

            vm.pager = null;

            const response = {};
            response.pageSize = 10;

            vm.users = vm.company.users.slice((button - 1) * response.pageSize, (button - 1) * response.pageSize + response.pageSize);
            
            response.count = vm.company.users.length > response.pageSize ? response.pageSize : vm.company.users.length;
            response.total = vm.company.users.length;
            
            response.totalPages = Math.ceil(vm.company.users.length / response.pageSize);
            response.currentPage = button;
            vm.pager = new Pager(response);
        }
        vm.hasSocial = false;
        accountsService.getAuthenticatedAccount().then(function(data) {
            vm.account = data;
            if (vm.account.accountType === 1 || vm.account.accountType === 5)
                companyService.getCompanyById(vm.account.companyId).then(function (data) {
                    vm.company = data;
                    vm.getUsers(1);
                    var admins = [];

                    vm.company.users.forEach(function(user) {
                        user.isSelected = false;
                        if (user.id === vm.account.accountId) {
                            user.isSelected = true;
                            vm.selectedUsers.push({ name: user.firstName + ' ' +  user.lastName, id: user.id });
                        }
                        if (user.type === 1) {
                            admins.push(user);
                        }
                    });
                    vm.companyAdmin = admins;
                    vm.hasSocial =
                        vm.company.environments.filter(function(en) { if (en.ssoClient.type == 14) return en }).length > 0;

                });
        });

        vm.selectUser = function (user) {

            if (user.id === vm.account.accountId)
                return;

            user.isSelected = !user.isSelected;
            if (user.isSelected) {
                if (vm.selectedUsers.filter(function (x) { if (x.id === user.id) return x; else return false;}).length !== -1) {
                    vm.selectedUsers.push({ name: user.firstName + ' ' +   user.lastName, id: user.id });
                }
            }
            else {
                if (vm.selectedUsers.filter(function (x) { if (x.id === user.id) return x; else return false;}).length > 0) {
                    const index = vm.selectedUsers.findIndex(function (x) { if (x.id === user.id) return x; else return false;});
                    if (index !== -1) {
                        vm.selectedUsers.splice(index, 1);
                    }
                }
            }
        }

        $('#ConfirmSelection').on('hide.bs.modal', function() {
            $('#ConfirmSelection .modal-content').css('display', 'none');
        });

        vm.next = function() {
            $('#ConfirmSelection').modal('show');
            $('#ConfirmSelection .modal-content').css('display','flex');
        }

        vm.processing = false;
        vm.working = true;

        vm.beginProcessing = function() {
            vm.processing = true;
            vm.working = true;
            $('#ConfirmSelection').modal('hide');
            const createEnvironment = {
                account: vm.account.accountId,
                users :[]
            };

            vm.selectedUsers.forEach(function(user) {
                createEnvironment.users.push(user.id);
            });
            
            accountsService.addSocialEnvironment(createEnvironment).then(function() {
                vm.working = false;
            });
           
        };

        vm.dissmiss = function() {
            $('#ConfirmSelection').modal('hide');
        };

        vm.complete = function() {
            window.location = '/dashboard';
        }        

    }
})();

